import ServicePage from '../components/service/ServicePage'

export default function MontajTrim() {
  return <ServicePage service="assembly" lang="tr" />
}
